var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 21
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  fillRule: "evenodd",
  d: "M2.148 4.059v2.885H.034v3.528h2.114v10.485H6.49V10.473h2.914s.273-1.692.405-3.542H6.507V4.519c0-.36.473-.846.941-.846h2.366V0H6.597c-4.557 0-4.45 3.532-4.45 4.059z"
})));
export default SvgFacebook;